import { Injectable } from "@angular/core";

import { UserNotificationListResponse } from "@app/core/notifications/domain/user-notification-list-response";
import {
  NotificationListApiResponse,
  NotificationListItemApiResponse,
} from "@app/core/shared/domain/api-types-filtered";

@Injectable({
  providedIn: "root",
})
export class UserNotificationListResponseMapper {
  static deserialize(dto: NotificationListApiResponse): UserNotificationListResponse {
    return {
      numNotifications: dto.num_notifications,
      numUnreadNotifications: dto.num_unread_notifications,
      notifications: dto.notifications.map(
        (notification: NotificationListItemApiResponse) => ({
          id: notification.id,
          title: notification.subtitle,
          contents: notification.contents,
          isRead: notification.read,
          url: notification.url,
          hasBanner: notification.has_banner,
        })
      ),
    };
  }
}
